<template>
    &nbsp;
    <span class="font-mono bg-gray-700 text-green-400 rounded p-0">
        <slot></slot>
    </span>
</template>
